"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureInfoListModel = void 0;
var mobx_1 = require("mobx");
var js_file_download_1 = __importDefault(require("js-file-download"));
var SignatureInfoListModel = /** @class */ (function () {
    function SignatureInfoListModel(fileTitle, deleteSignature, downloadSignature) {
        this.signatureInfoList = [];
        this.isSingleSignature = true;
        this.fileTitle = fileTitle;
        this.deleteSignature = deleteSignature;
        this.downloadSignature = downloadSignature;
    }
    SignatureInfoListModel.prototype.load = function (dto) {
        this.signatureInfoList = dto;
        this.isSingleSignature = dto.length < 2;
    };
    SignatureInfoListModel.prototype.download = function (isWithFile) {
        var _this = this;
        this.downloadSignature(isWithFile).then(function (file) { return js_file_download_1.default(file, _this.fileTitle + ".sig"); });
    };
    SignatureInfoListModel.prototype.delete = function (onSuccess) {
        this.deleteSignature().then(onSuccess);
    };
    __decorate([
        mobx_1.observable
    ], SignatureInfoListModel.prototype, "signatureInfoList", void 0);
    __decorate([
        mobx_1.observable
    ], SignatureInfoListModel.prototype, "isSingleSignature", void 0);
    __decorate([
        mobx_1.observable
    ], SignatureInfoListModel.prototype, "fileTitle", void 0);
    __decorate([
        mobx_1.observable
    ], SignatureInfoListModel.prototype, "deleteSignature", void 0);
    __decorate([
        mobx_1.observable
    ], SignatureInfoListModel.prototype, "downloadSignature", void 0);
    __decorate([
        mobx_1.action.bound
    ], SignatureInfoListModel.prototype, "load", null);
    __decorate([
        mobx_1.action.bound
    ], SignatureInfoListModel.prototype, "download", null);
    __decorate([
        mobx_1.action.bound
    ], SignatureInfoListModel.prototype, "delete", null);
    return SignatureInfoListModel;
}());
exports.SignatureInfoListModel = SignatureInfoListModel;
